import { render } from "./ButtonsGroup.vue?vue&type=template&id=33fcb382"
import script from "./ButtonsGroup.vue?vue&type=script&lang=js"
export * from "./ButtonsGroup.vue?vue&type=script&lang=js"
script.render = render

export default script